export const LIDO_PROGRAM_ID = 'CrX7kMhLC3cSsXJdT7JDgqrRVWGnUpX3gfEfxxU2NVLi'
export const LIDO_PROGRAM_ID_DEVNET =
  'CbxVmURN74QZGuFj6qKjM8VDM8b8KKZrbPFLM2CC2hC8'
